var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessOfferFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,12h18l5,9 -5,15H15L10,21z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18,11h3v10h-3zM23,11h3v10h-3zM28,11h3v10h-3z",
    fill: "#FFD000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22h16l-2.8,10H18.8z",
    fill: "#E53935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19,27h10v2H19z",
    fill: "#00D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessOfferFood);
export default __webpack_public_path__ + "static/media/p4r_business_offer_food.6231a297697cf02bf767931aff93fb4a.svg";
export { ForwardRef as ReactComponent };